import { render, staticRenderFns } from "./routingrules.vue?vue&type=template&id=28f3a8e4"
import script from "./routingrules.vue?vue&type=script&lang=js"
export * from "./routingrules.vue?vue&type=script&lang=js"
import style0 from "./routingrules.vue?vue&type=style&index=0&id=28f3a8e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports